import React from "react"
import PropTypes from "prop-types"
import { HorizontalPlanPriceBox } from "./horizontal-plan-price-box"
import "./horizontal-plan.scss"
import HorizontalPlanHeader from "./horizontal-plan-header"
import HorizontalPlanDetails from "./horizontal-plan-details"
import { useSelector } from "react-redux"
import { hasRelativePricing } from "redux/selectors/plan-selectors"
import { useEFSData } from "hooks/efs-input"
import {
  GetRelativePricing,
  GetRelativeOOCPricing
} from "services/relativePricing/relativePricing.service"
import { CapAmount } from "utils/string_utils"

export const HorizontalPlan = ({
  id,
  data,
  costs,
  benefits,
  onSelectPlan,
  pageToShowEntertainment,
  storeName
}) => {
  const { currentPrice, uncappedPrice } = useEFSData()
  const useRelativePricing = useSelector(hasRelativePricing)

  let relativePrice = null
  let relativeOOC = null

  // Use relative pricing only if this plan uses it
  // and their current price is lower than the max cap
  if (useRelativePricing && uncappedPrice <= currentPrice) {
    relativePrice = GetRelativePricing(costs.maf, currentPrice)

    let totalOOC = costs.ooc + costs.maf
    if (costs.oocCap && !data.ignoreOOCCap) {
      totalOOC = CapAmount(totalOOC, costs.oocCap)
    }

    relativeOOC = costs.ooc && GetRelativeOOCPricing(totalOOC, currentPrice)
  }

  return (
    <div className="hplan">
      <HorizontalPlanHeader data={data} storeName={storeName} />
      <HorizontalPlanDetails
        benefits={benefits}
        data={data}
        pageToShowEntertainment={pageToShowEntertainment}
        onSelectPlan={onSelectPlan}
        id={id}
      />
      <HorizontalPlanPriceBox
        relativePrice={relativePrice}
        relativeOOC={relativeOOC}
        costs={costs}
        data={data}
        storeName={storeName}
        pageToShowEntertainment={pageToShowEntertainment}
        benefits={benefits}
        onSelectPlan={onSelectPlan}
        id={id}
      />
    </div>
  )
}

HorizontalPlan.propTypes = {
  id: PropTypes.string,
  data: PropTypes.shape({
    name: PropTypes.string.isRequired,
    minutes: PropTypes.string,
    texts: PropTypes.string,
    data: PropTypes.string.isRequired,
    contractLength: PropTypes.string.isRequired,
    network: PropTypes.string,
    speed: PropTypes.string,
    speedBolts: PropTypes.number,
    speedList: PropTypes.object,
    speedIcons: PropTypes.arrayOf(PropTypes.string)
  }),
  costs: PropTypes.shape({
    airtime: PropTypes.number,
    handset: PropTypes.number,
    maf: PropTypes.number,
    upfront: PropTypes.number,
    ooc: PropTypes.number
  }),
  style: PropTypes.string.isRequired,
  benefits: PropTypes.object,
  onSelectPlan: PropTypes.func,
  pageToShowEntertainment: PropTypes.string,
  storeName: PropTypes.string,
  excludeVAT: PropTypes.bool,
  getPlanOptionWithName: PropTypes.func
}

HorizontalPlan.defaultProps = {
  benefits: undefined,
  excludeVAT: false
}

export default HorizontalPlan
